export const scrollVideoContent = {
  ariaLabel: 'Пролёт от квартала к яхте',
  startText: 'Всё ближе, чем кажется',
  middleText: 'ДРАКОН!',
  endText: 'В центре событий',
};
